import styled, { css } from "styled-components";
import { device } from "../../../globalStyles/breakpoints";

const ColumnGridCommonStyles = css`
  display: grid;
  width: 100%;
  margin-top: 30px;
  grid-column-gap: 27px;
  grid-row-gap: 45px;
`;

export const ThreeColumnGrid = styled.div`
  ${ColumnGridCommonStyles}
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;

export const TwoColumnGrid = styled.div`
  ${ColumnGridCommonStyles}
  grid-template-columns: repeat(auto-fit, minmax(48%, 1fr));
`;
